import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { MusicalNoteIcon, ListBulletIcon, CalendarIcon, Cog6ToothIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission } from '../constants/roles';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { user } = useAuth();
  const roles = user?.roles || [];

  const menuItems = [
    { to: '/songs', icon: MusicalNoteIcon, label: 'Songs' },
    { to: '/setlists', icon: ListBulletIcon, label: 'Set Lists' },
    { to: '/shows', icon: CalendarIcon, label: 'Shows' }
  ];

  const showSettings = hasPermission(roles, 'settings');

  return (
    <aside className={`${isCollapsed ? 'w-16' : 'w-64'} bg-white border-r border-gray-200 transition-all duration-300 flex flex-col`}>
      {/* Toggle Button */}
      <div className="flex justify-end p-2">
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? (
            <ChevronRightIcon className="w-4 h-4" />
          ) : (
            <ChevronLeftIcon className="w-4 h-4" />
          )}
        </button>
      </div>

      <div className="flex-1 overflow-auto">
        <nav className="mt-4">
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center ${isCollapsed ? 'px-4 justify-center' : 'px-6'} py-3 text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'text-blue-600 bg-blue-50 border-r-2 border-blue-600'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`
                }
                title={isCollapsed ? item.label : ''}
              >
                <IconComponent className={`w-5 h-5 ${!isCollapsed ? 'mr-3' : ''}`} />
                {!isCollapsed && (
                  <span className="whitespace-nowrap">{item.label}</span>
                )}
              </NavLink>
            );
          })}
        </nav>
      </div>

      {showSettings && (
        <div className="border-t border-gray-200">
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `flex items-center ${isCollapsed ? 'px-4 justify-center' : 'px-6'} py-3 text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'text-blue-600 bg-blue-50 border-r-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`
            }
            title={isCollapsed ? 'Settings' : ''}
          >
            <Cog6ToothIcon className={`w-5 h-5 ${!isCollapsed ? 'mr-3' : ''}`} />
            {!isCollapsed && (
              <span className="whitespace-nowrap">Settings</span>
            )}
          </NavLink>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
